import { DETAILS_FETCH_REQUEST, DETAILS_FETCH_SUCCESS, DETAILS_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    details: {},
    error: ''
}

const details = (state = initialState, action) => {
    switch (action.type) {
        case DETAILS_FETCH_REQUEST:
            return {
                loading: true,
                details: {},
                error: '',
            }
        case DETAILS_FETCH_SUCCESS:
            return {
                loading: false,
                details: action.payload,
                error: ''
            }
        case DETAILS_FETCH_FAILURE:
            return {
                loading: false,
                details: {},
                error: action.payload
            }
        default: return state
    }
}

export default details;